import mod from "-!../../../../node_modules/babel-loader/lib/index.js??ref--1-0!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pz-form.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--1-0!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pz-form.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ../assets/js/personalize/components/pz-form.vue?vue&type=script&lang=js&
// module id = 23
// module chunks = 0